import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import Caption from '../../../Theme/Fonts/Caption'
import { TextColorTypes } from '../../../Theme/Fonts/FontTypes'

interface PagingProps {
    onNext: () => void
    color: TextColorTypes
    text: string
}

const Paging: FunctionComponent<PagingProps> = ({ onNext, color, text }): ReactElement => {
    return (
        <Touchable onPress={onNext}>
            <Grid horizontal centerVertical>
                <Grid noExpand maxWidth={70} marginRight={4}>
                    <Caption color={color} uppercase bold textAlign="right">
                        {text}
                    </Caption>
                </Grid>
                <FontelloIcon name="scroll-right" color={color} fontSize={13} />
            </Grid>
        </Touchable>
    )
}

export default memo(Paging)
